var exports = {
  "G": "xe564cbfb--fd4105--tooltip-content",
};

module.exports = exports;
